import { useState, useEffect } from "react";
import axios from "axios";

// @mui
import {
  Card,
  Table,
  Tooltip,
  Divider,
  TableBody,
  Container,
  IconButton,
  TableContainer,
  Dialog,
} from "@mui/material";
// routes
import { getAllUsersOfVenue } from "src/redux/slices/venueUser";
// components
import Iconify from "../../../../components/iconify";
import Scrollbar from "../../../../components/scrollbar";

import { useSettingsContext } from "../../../../components/settings";
import {
  useTable,
  getComparator,
  emptyRows,
  TableNoData,
  TableEmptyRows,
  TableHeadCustom,
  TableSelectedAction,
  TablePaginationCustom,
} from "../../../../components/table";
// sections
import UserReservationDetailModal from "./UserReservationDetailModal";
import {
  onOpenModalUserReservationdetailPopup,
  onCloseModalForUserReservationDetail,
} from "src/redux/slices/customerReservationSlice";
import CustomerReservationTableRow from "./CustomerReservationTableRow";
import CustomerReservationTableToolbar from "./CustomerReservationTableToolbar";
import { useAuthContext } from "src/auth/useAuthContext";
import { useDispatch, useSelector } from "react-redux";
import setSixAM from "src/utils/setTimeTo6Am";
// ----------------------------------------------------------------------

let dataToPrint = null;
const formatTime = (time) => {
  const options = { hour: "2-digit", minute: "2-digit", hour12: true };
  return new Intl.DateTimeFormat("en-US", options).format(time);
};

const formatDate = (time) => {
  const options = { day: "numeric", month: "short", year: "numeric" };
  return new Intl.DateTimeFormat("en-US", options).format(time);
};

export default function CustomerReservationListPage({ phone }) {
  const {
    dense,
    page,
    order,
    orderBy,
    rowsPerPage,
    setPage,
    //
    selected,
    setSelected,
    onSelectRow,
    onSelectAllRows,
    //
    onSort,
    onChangeDense,
    onChangePage,
    onChangeRowsPerPage,
  } = useTable();

  const { user } = useAuthContext();
  const TABLE_HEAD = [
    { id: "reservationNo", label: "Reservation#", align: "left" },
    { id: "createdAt", label: "Date", align: "left", sort: "descending" },
    { id: "createdAt", label: "Time", align: "left" },
    // { id: "paymentType", label: "Payment Type", align: "left" },
    { id: "reservationType", label: "Reservation Type", align: "left" },
    { id: "partySize", label: "party Size", align: "left" },
    { id: "origin", label: "origin", align: "left" },
    { id: "advancePayment", label: "Amount", align: "left" },
    { id: "advancePayment", label: "Payment Status", align: "left" },
    { id: "status", label: "Status", align: "left" },
  ];

  const { themeStretch } = useSettingsContext();

  let dispatch = useDispatch();

  const getToken = sessionStorage.getItem("accessToken");
  const [openConfirm, setOpenConfirm] = useState(false);

  const [filterName, setFilterName] = useState("");

  const [orderListData, setOrderListData] = useState([]);

  // --- 90 days filter logic start ---
  // Get venue reset time
  const dateObj = new Date(user.venue.resetTime);
  const hour = dateObj.getHours();
  const minutes = dateObj.getMinutes();

  // End date: today (or next day, per your logic)
  const endDateTime = new Date();
  setSixAM(endDateTime, hour, minutes);
  let currentHour = endDateTime.getHours();
  let currentMinutes = endDateTime.getMinutes();
  if (
    (currentHour >= 0 && currentHour < hour) ||
    (currentHour == hour && currentMinutes < minutes)
  ) {
    // before reset time, end date is today at reset time
    // do nothing
  } else {
    // after reset time, end date is next day at reset time
    endDateTime.setDate(endDateTime.getDate() + 1);
  }

  // Start date: 90 days before end date
  const startDateTime = new Date(endDateTime);
  startDateTime.setDate(startDateTime.getDate() - 90);
  setSixAM(startDateTime, hour, minutes);
  // --- 90 days filter logic end ---

  const [filterEndDate, setFilterEndDate] = useState(endDateTime);
  const [filterStartDate, setFilterStartDate] = useState(startDateTime);

  const { openModalUserReservationDetail } = useSelector(
    (state) => state.customerReservationSlice
  );

  const dataFiltered = applyFilter({
    inputData: orderListData,
    comparator: getComparator(order, orderBy),
    filterName,
    filterStartDate,
    filterEndDate,
    user,
  });

  const getOrders = async (startDate, endDate) => {
    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL;
      const getToken = sessionStorage.getItem("accessToken");
      const level = JSON.parse(sessionStorage.getItem("levelSelected"));
      // const defaultStartDate = new Date();
      // defaultStartDate.setHours(6, 0, 0, 0);
      // const startDateToSend = startDate
      //   ? startDate.toISOString()
      //   : defaultStartDate.toISOString();
      // const defaultEndDate = new Date();
      // defaultEndDate.setHours(6, 0, 0, 0);
      // defaultEndDate.setDate(defaultEndDate.getDate() + 1);
      // const endDateToSend = endDate
      //   ? endDate.toISOString()
      //   : defaultEndDate.toISOString();
      const response = await axios.get(
        `${backendUrl}/venueCustomer/getReservationByPhoneNumber`,
        {
          headers: {
            Authorization: `Bearer ${getToken}`,
          },
          params: {
            venueId: user.venue.id,
            levelId: level.id,
            phone: phone,
            startDate: startDate.toISOString(),
            endDate: endDate.toISOString(),
          },
        }
      );

      const completedOrders = response.data;

      setOrderListData(completedOrders);
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    getOrders(filterStartDate, filterEndDate);
  }, [filterStartDate, filterEndDate]);

  useEffect(() => {
    onSort("createdAt");
  }, []);
  useEffect(() => {
    const level = JSON.parse(sessionStorage.getItem("levelSelected"));
    dispatch(getAllUsersOfVenue(user?.venue?.id, getToken));
  }, [dispatch, user?.venue?.id]);

  const dataInPage = dataFiltered.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const denseHeight = dense ? 52 : 72;

  const isFiltered =
    filterName !== "" || (!!filterStartDate && !!filterEndDate);
  const isNotFound =
    (!dataFiltered.length && !!filterName) ||
    (!dataFiltered.length && !!filterEndDate) ||
    (!dataFiltered.length && !!filterStartDate);

  const handleOpenConfirm = () => {
    setOpenConfirm(true);
  };

  const handleFilterName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const handleResetFilter = () => {
    setFilterName("");
    // Reset to 90 days window
    const resetEndDate = new Date();
    setSixAM(resetEndDate, hour, minutes);
    let resetCurrentHour = resetEndDate.getHours();
    let resetCurrentMinutes = resetEndDate.getMinutes();
    if (
      (resetCurrentHour >= 0 && resetCurrentHour < hour) ||
      (resetCurrentHour == hour && resetCurrentMinutes < minutes)
    ) {
      // before reset time, end date is today at reset time
      // do nothing
    } else {
      // after reset time, end date is next day at reset time
      resetEndDate.setDate(resetEndDate.getDate() + 1);
    }
    const resetStartDate = new Date(resetEndDate);
    resetStartDate.setDate(resetStartDate.getDate() - 90);
    setSixAM(resetStartDate, hour, minutes);
    setFilterStartDate(resetStartDate);
    setFilterEndDate(resetEndDate);
  };

  const [singleData, setSingleData] = useState();
  const getSingleData = (row) => {
    setSingleData(row);
  };

  useEffect(() => {
    // Set default 90 days window on mount
    const currentEndDate = new Date();
    setSixAM(currentEndDate, hour, minutes);
    let currHour = currentEndDate.getHours();
    let currMinutes = currentEndDate.getMinutes();
    if (
      (currHour >= 0 && currHour < hour) ||
      (currHour == hour && currMinutes < minutes)
    ) {
      // before reset time, end date is today at reset time
      // do nothing
    } else {
      // after reset time, end date is next day at reset time
      currentEndDate.setDate(currentEndDate.getDate() + 1);
    }
    const currentStartDate = new Date(currentEndDate);
    currentStartDate.setDate(currentStartDate.getDate() - 90);
    setSixAM(currentStartDate, hour, minutes);
    setFilterStartDate(currentStartDate);
    setFilterEndDate(currentEndDate);
  }, []);

  const handleOpenUserReservationDetailModal = () => {
    dispatch(onOpenModalUserReservationdetailPopup());
  };

  const handleCloseModal = () => {
    dispatch(onCloseModalForUserReservationDetail());
  };

  return (
    <>
      <Card>
        <CustomerReservationTableToolbar
          isFiltered={isFiltered}
          filterName={filterName}
          onFilterName={handleFilterName}
          onResetFilter={handleResetFilter}
          filterEndDate={filterEndDate}
          filterStartDate={filterStartDate}
          onFilterStartDate={(newValue) => {
            setFilterStartDate(newValue);
          }}
          onFilterEndDate={(newValue) => {
            setFilterEndDate(newValue);
          }}
          dataFiltered={dataToPrint}
          user={user}
        />

        <TableContainer sx={{ position: "relative", overflow: "unset" }}>
          <TableSelectedAction
            dense={dense}
            numSelected={selected.length}
            rowCount={orderListData.length}
            onSelectAllRows={(checked) =>
              onSelectAllRows(
                checked,
                orderListData.map((row) => row.id)
              )
            }
            action={
              <Tooltip title="Delete">
                <IconButton color="primary" onClick={handleOpenConfirm}>
                  <Iconify icon="eva:trash-2-outline" />
                </IconButton>
              </Tooltip>
            }
          />

          <Scrollbar>
            <Table size={dense ? "small" : "medium"} sx={{ minWidth: 800 }}>
              <TableHeadCustom
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={dataFiltered.length}
                numSelected={selected.length}
                onSort={onSort}
                onSelectAllRows={false}
              />

              <TableBody>
                {dataFiltered
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => (
                    <CustomerReservationTableRow
                      key={row.id}
                      row={row}
                      selected={selected.includes(row.id)}
                      onSelectRow={() => onSelectRow(row.id)}
                      getSingleData={getSingleData}
                      handleOpenUserReservationDetailModal={
                        handleOpenUserReservationDetailModal
                      }
                      venue={user.venue}
                    />
                  ))}

                <TableEmptyRows
                  height={denseHeight}
                  emptyRows={emptyRows(page, rowsPerPage, dataFiltered.length)}
                />

                <TableNoData isNotFound={isNotFound} />
              </TableBody>
            </Table>
          </Scrollbar>
        </TableContainer>

        <TablePaginationCustom
          count={dataFiltered.length}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={onChangePage}
          onRowsPerPageChange={onChangeRowsPerPage}
          //
          dense={dense}
          onChangeDense={onChangeDense}
        />
      </Card>
      <Dialog
        fullWidth
        maxWidth="sm"
        open={openModalUserReservationDetail}
        onClose={handleCloseModal}
      >
        <UserReservationDetailModal
          title="Reservation Detail"
          singleData={singleData}
        />
      </Dialog>
    </>
  );
}

// ----------------------------------------------------------------------

function applyFilter({
  inputData,
  comparator,
  filterName,
  filterStartDate,
  filterEndDate,
  user,
}) {
  const stabilizedThis = inputData.map((el, index) => [el, index]);

  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  inputData = stabilizedThis.map((el) => el[0]);

  if (filterName) {
    inputData = inputData.filter((customer) => {
      const nameMatch = customer.name
        ?.toLowerCase()
        .includes(filterName.toLowerCase());

      const reservationNoMatch = customer?.reservationNo
        ?.toString()
        .includes(filterName);

      const paymentTypeMatch = customer?.paymentType
        ?.toLowerCase()
        .includes(filterName.toLowerCase());

      const reservationTypeMatch = customer?.reservationType
        ?.toLowerCase()
        .includes(filterName.toLowerCase());

      const partySizeMatch = customer?.partySize
        ?.toString()
        .includes(filterName);
      const originMatch = customer?.origin
        ?.toLowerCase()
        .includes(filterName.toLowerCase());

      const stateMatch = customer?.state
        ?.toLowerCase()
        .includes(filterName.toLowerCase());

      return (
        nameMatch ||
        reservationTypeMatch ||
        partySizeMatch ||
        stateMatch ||
        originMatch ||
        reservationNoMatch ||
        paymentTypeMatch
      );
    });
  }

  if (filterStartDate && filterEndDate) {
    inputData = inputData.filter(
      (customer) =>
        new Date(customer.createdAt) >= new Date(filterStartDate).getTime() &&
        new Date(customer.createdAt) <= new Date(filterEndDate).getTime()
    );
  }

  return inputData;
}
